/**
 * Front-end application
 *
 * Load the app content and the blocks front-end code
 */

/**
 * Internal dependencies
 */

// Scripts
import '../app/js/app.js';

// Styles
import '../stylus/digital-edition.styl';

// Blocks Front
import '../blocks/image/front';

const digitalEdition = document.querySelector('.digital-edition-modal');

if (null !== digitalEdition) {
	const loginToggle = document.querySelectorAll('.digital-edition-toggle');
	const loginClose = document.querySelector(
		'.digital-edition-modal .modal__close'
	);
	const closePopup = () => {
		digitalEdition.classList.remove('modal--open');
	};

	loginToggle.forEach(function (btn) {
		btn.onclick = () => {
			digitalEdition.classList.add('modal--open');
		};
	});

	loginClose.onclick = () => {
		closePopup();
	};

	document.addEventListener('keydown', (event) => {
		if (event.key !== 'Escape') {
			return;
		}
		closePopup();
	});
}
